var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { reactive } from "vue";
import ComponentGrantEndpoints from "src/shared/api/component/grant/ComponentGrantEndpoints";
import { ComponentGrant } from "src/shared/store/component-grant/model/ComponentGrant";
import { ComponentGranter } from "src/shared/store/component-grant/model/ComponentGranter";
import notificationService from "src/shared/notification/notification-service";
export const useComponentGrantStore = defineStore("componentGrantStore", () => {
    const state = reactive({
        grants: {},
        granters: {},
    });
    const setGrants = (grantResponses) => {
        return grantResponses.map((response) => {
            const grant = new ComponentGrant(response);
            state.grants[grant.grant_id] = grant;
            return grant;
        });
    };
    const setGranters = (granterResponses) => {
        return granterResponses.map((response) => {
            const granter = new ComponentGranter(response);
            state.granters[granter.grant_id] = granter;
            return granter;
        });
    };
    const fetchGrants = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield ComponentGrantEndpoints.list();
            return setGrants(response.data);
        }
        catch (error) {
            notificationService.error(error);
            throw error;
        }
    });
    const grant = (request) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield ComponentGrantEndpoints.grant(request);
            const grant = new ComponentGrant(response.data);
            state.grants[grant.grant_id] = grant;
            return grant;
        }
        catch (error) {
            notificationService.error(error);
            throw error;
        }
    });
    const grantAll = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield ComponentGrantEndpoints.grantAll();
            const grant = new ComponentGrant(response.data);
            state.grants[grant.grant_id] = grant;
            return grant;
        }
        catch (error) {
            notificationService.error(error);
            throw error;
        }
    });
    const revoke = (grantId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield ComponentGrantEndpoints.revoke(grantId);
            const grant = new ComponentGrant(response.data);
            delete state.grants[grantId];
            return grant;
        }
        catch (error) {
            notificationService.error(error);
            throw error;
        }
    });
    const fetchGranters = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield ComponentGrantEndpoints.listGranters();
            return setGranters(response.data);
        }
        catch (error) {
            notificationService.error(error);
            throw error;
        }
    });
    const getGrants = () => {
        return Object.values(state.grants);
    };
    const getGrant = (grantId) => {
        return state.grants[grantId];
    };
    const getGranters = () => {
        return Object.values(state.granters);
    };
    const getGranter = (grantId) => {
        return state.granters[grantId];
    };
    const clearGrants = () => {
        state.grants = {};
    };
    const clearGranters = () => {
        state.granters = {};
    };
    return {
        state,
        fetchGrants,
        grant,
        grantAll,
        revoke,
        fetchGranters,
        getGrants,
        getGrant,
        getGranters,
        getGranter,
        clearGrants,
        clearGranters,
    };
});
